import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { LANGUAGES, DEFAULT_LANG, tr } from "./translations";

const LangCtx = createContext(null);

function detectInitialLang() {
  if (typeof window === "undefined") return DEFAULT_LANG;
  try {
    const saved = localStorage.getItem("preferred-lang");
    if (saved && LANGUAGES.some((l) => l.code === saved)) return saved;
    const nav = (navigator.language || navigator.userLanguage || "").toLowerCase();
    const code = nav.split("-")[0];
    if (LANGUAGES.some((l) => l.code === code)) return code;
  } catch (_e) { /* noop */ }
  return DEFAULT_LANG;
}

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(detectInitialLang);

  useEffect(() => {
    try {
      localStorage.setItem("preferred-lang", lang);
      document.documentElement.lang = lang;
    } catch (_e) { /* noop */ }
  }, [lang]);

  const setLang = useCallback((code) => {
    if (LANGUAGES.some((l) => l.code === code)) setLangState(code);
  }, []);

  const t = useCallback((key) => tr(key, lang), [lang]);

  return (
    <LangCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LangCtx.Provider>
  );
}

export function useT() {
  const ctx = useContext(LangCtx);
  if (!ctx) throw new Error("useT must be used inside LanguageProvider");
  return ctx;
}
